export default __webpack_public_path__ + "static/media/sn_16299738424454.b6dda50a.webp";